/**
 * Swish (Wishlist King) theme bridge.
 * Keeps theme-side header/mobile dock counters in sync with Swish events,
 * and forces a hard navigation to /apps/wishlist (avoids stale "no favorites"
 * state caused by instant.page prefetching the app proxy URL).
 *
 * The actual product / collection / page wishlist UI is owned by Swish app
 * blocks; do NOT inject <wishlist-button-product> manually — see
 * https://docs.swish.app/theme-extensions/product-page-buttons
 */
(function () {
  'use strict';

  function markWishlistLinksNoInstant() {
    document.querySelectorAll('a[href*="/apps/wishlist"]').forEach(function (link) {
      link.setAttribute('data-no-instant', '');
    });
  }

  function setWishlistCounters(value) {
    document.querySelectorAll('.wkh-counter').forEach(function (el) {
      el.textContent = String(value);
      var btn = el.closest('.wkh-button');
      if (btn) btn.classList.toggle('wkh-selected', value > 0);
    });
  }

  function onWishlistEvent(event) {
    var d = event && event.detail;
    if (!d) return;
    if (typeof d.numItems === 'number') {
      setWishlistCounters(d.numItems);
      return;
    }
    if (d.wishlist && typeof d.wishlist.numItems === 'number') {
      setWishlistCounters(d.wishlist.numItems);
    }
  }

  ['wk:wishlist:add:success', 'wk:wishlist:remove:success', 'wk:wishlist:clear:success'].forEach(function (name) {
    document.addEventListener(name, onWishlistEvent);
    window.addEventListener(name, onWishlistEvent);
  });

  markWishlistLinksNoInstant();
  document.addEventListener('shopify:section:load', markWishlistLinksNoInstant);
})();
